module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-bildung-3eafe2dec9df6ad8f55c3e61202bc705.svg";